import { zodResolver } from "@hookform/resolvers/zod";
import { CreateOrderRequest } from "services/orders/models/OrdersTypes";
import { z } from "zod";
import {ProgramByIDResponse} from "../../../../services/programs/models/ProgramTypes";

export const getCreateOrderSchema = (t: any,program?:ProgramByIDResponse |null ) => {
  const schema = z.object({
    programId: z
      .number({
        message: t("Common:invalidValue"),
      })
      .min(1, t("Common:invalidValue")),
    centreManagementId:program == null? z.number().optional() : program.isCentreManagementRequired?z.number().min(1, t("Common:requiredField")):z.number().optional(),
    formSubject:program == null? z.string().optional() : program.isFromSubjectRequired?z.string().min(1, t("Common:requiredField")):z.string().optional(),
    formValue: z.string().optional(),
    isAcceptedConditionAndRules: z.boolean().refine((value) => value === true, {
      message: t("Common:requiredField"),
    }),
    isAcceptedCommitments: z.boolean().refine((value) => value === true, {
      message: t("Common:requiredField"),
    }),
    filesIds:program == null? z
      .array(
        z.string({
          message: t("Common:pleaseUploadAtLeastOneFile"),
        }),
      ) .optional() :program.isFileAttachmentRequired? z. array(
        z.string({
          message: t("Common:pleaseUploadAtLeastOneFile"),
        }),
    ).min(1, t("Common:pleaseUploadAtLeastOneFile")):z.array(z.string({
      message: t("Common:pleaseUploadAtLeastOneFile"),
    }).optional()),
    researchFieldId:program == null?  z.number().optional(): program.isResearchFieldRequired?z.number().min(1, t("Common:requiredField")):z.number().optional(),
    subspecialty: z.string().optional(),
    isFormValueReady: z
      .boolean({ message: t("pleaseFillAllRequiredFields") })
      .refine((value) => value === true, { message: t("pleaseFillAllRequiredFields") }),
    isDraft: z.boolean(),
  }) as z.ZodType<CreateOrderRequest>;

  return zodResolver(schema);
};
